import {
  fetchAppointments,
  fetchAppointmentsExport,
  sendDataProcessing,
  getCauseList,
} from "../../helpers/fetching";

export default {
  state: {
    token: "N66f6FM25LpbG061CA7jdufsh1AUJXkKTRqpsiiG",
    url: "https://appointments.sales.debmedia.com/",
    schedule: {},
    appointments: [],
    appointmentsExport: [],
    loadingAppointments: false,
    error: null,
    responseAppointment: {},
    loading: false,
  },
  mutations: {
    clearError(state) {
      state.error = null;
    },
    setAppointments(state, data) {
      state.appointments = data;
      state.error = null;
    },
    setAppointmentsExport(state, data) {
      state.appointmentsExport = data;
      state.error = null;
    },
    setProfile(state, data) {
      state.profileData = data;
      state.loadingAppointments = false;
      state.error = null;
    },
    setSchedule(state, data) {
      state.schedule = data;
      state.loadingAppointments = false;
      state.error = null;
    },
    setURLAppointmets(state, data) {
      state.url = data;
    },
    setTokenAppointmets(state, data) {
      state.token = data;
    },
    setLoading(state, data) {
      state.loading = data;
    },
    setResponseAppointments(state, data) {
      state.responseAppointment = data;
    },
    setError(state, data) {
      state.error = data;
    },
  },
  actions: {
    fetchSchedule({ state, commit }, params) {
      if (typeof params !== "object") {
        console.log(params);
        return Promise.reject(
          new Error("Invalid paramethers for fetch schedule")
        );
      }

      return new Promise((resolve) => {
        commit("setLoading", true);

        var myHeaders = new Headers();
        myHeaders.append("x-api-token", String(state.token));
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
          method: "GET",
          headers: myHeaders,
        };

        fetch(`${state.url}api/v2/schedules${params.queryData}`, requestOptions)
          .then((response) => response.text())
          .then((result) => {
            if (result) {
              let schedules = JSON.parse(result);
              let schedule = schedules.length ? schedules[0] : {};
              commit("setSchedule", schedule);
            }

            commit("setLoading", false);
            resolve();
          })
          .catch((error) => {
            console.error(error);
            commit("error", error);
            commit("setLoading", false);
          });
      });
    },
    fetchAppointments({ state, commit }, params) {
      return new Promise((resolve) => {
        commit("setLoading", true);

        fetchAppointments(
          `api_url=${state.url}api/v2/appointments&day=${
            params.day || ""
          }&email=${params.email}&dni=${params.dni}&state=${
            params.status
          }&branchId=${params.branchId || ""}&fromDate=${
            params.fromDate || ""
          }&toDate=${params.toDate || ""}`
        )
          .then((response) => {
            let appointments = response.data;

            if (appointments && params.searchPoint) {
              if (typeof params.searchPoint == "object") {
                appointments = appointments.filter((a) =>
                  params.searchPoint.includes(a.reason.point)
                );
              } else {
                appointments = appointments.filter(
                  (a) => a.reason.point == params.searchPoint
                );
              }
            }

            commit("setAppointments", appointments);
            commit("setLoading", false);
            resolve();
          })
          .catch((error) => {
            console.error(error);
            commit("error", error);
            commit("setLoading", false);
          });
      });
    },
    fetchExportAppointments({ state, commit }, params) {
      return new Promise((resolve) => {
        commit("setLoading", true);

        fetchAppointmentsExport(
          `api_url=${state.url}api/v2/appointments&day=${
            params.day || ""
          }&email=${params.email}&dni=${params.dni}&state=${
            params.status
          }&branchId=${params.branchId || ""}&fromDate=${
            params.fromDate || ""
          }&toDate=${params.toDate || ""}`,
          {
            "x-api-token": String(state.token),
          }
        )
          .then((response) => {
            commit("setAppointmentsExport", response.data);
            commit("setLoading", false);
            resolve();
          })
          .catch((error) => {
            console.error(error);
            commit("error", error);
            commit("setLoading", false);
          });
      });
    },
    AssignURLAppointmets({ commit }, params) {
      commit("setURLAppointmets", params);
    },
    AssignTokenAppointmets({ commit }, params) {
      commit("setTokenAppointmets", params);
    },
    updateAppointment({ commit }, params) {
      if (typeof params.data !== "object" || !params.data?.code) {
        return Promise.reject(
          new Error("Invalid paramethers for appointments updating")
        );
      }

      return new Promise((resolve) => {
        commit("setLoading", true);

        var myHeaders = new Headers();
        myHeaders.append(
          "x-api-token",
          String(params.headers.token_appointments)
        );
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
          branch: {
            id: params.data.branch,
          },
          status: params.data.status || "CANCELED",
          schedule: {
            id: params.data.schedule,
          },
          startAt: params.data.startAt,
          endAt: params.data.startAt,
        });

        var requestOptions = {
          method: "PUT",
          headers: myHeaders,
          body: raw,
        };

        fetch(
          `${params.url}api/v2/appointments/${params.data?.code}`,
          requestOptions
        )
          .then((response) => response.text())
          .then((result) => {
            commit("setResponseAppointments", JSON.parse(result));
            commit("setLoading", false);
            resolve();
          })
          .catch((error) => {
            console.error(error);
            commit("setError", error);
            commit("setLoading", false);
          });
      });
    },
    /* eslint-disable */
    setProcessing({ commit }, data) {
      return new Promise(async (resolve) => {
        commit("setLoading", true);
        await sendDataProcessing({
            session_uuid: window.person.id,
            origin_url: window.location.href,
            action: data.action,
            document: data.document,
            appointment_code: data.appointment_code,
            origin: "silver-agent",
        });
        commit("setLoading", false);
        resolve();
      });
    },

    sendExtraFields({commit}, data ){
      return new Promise(async (resolve) => {
        commit("setLoading", true);
        await sendDataProcessing({
          session_uuid: window.person.id,
          origin_url: window.location.href,
          action: data.action,
          document: data.document,
          appointment_code: data.appointment_code,
          origin: "silver-agent",
          efective: data.efective,
          reason: data.reason
        });
        commit("setLoading", false);
        resolve();
      });
    },

    fetchCauselList({ commit }, compnay){
      return new Promise(async (resolve) => {
        commit("setLoading", true);
        let response = await getCauseList(compnay);
        commit("setLoading", false);
        resolve(response);
      });
    },

    clearAppointments({ commit }) {
      commit("clearError");
      commit("setLoading", false);
      commit("setAppointments", []);
      commit("setAppointmentsExport", []);
    },
  },
};
